<template>
    <div class="invite">
      <div class="title bold">Invite some people over</div>
      <form class="email-input" @submit.prevent="act(currentEmail); clearData()">
        <input
          type="email"
          name="email"
          placeholder="e.g. ciao@superidea.com"
          v-model="currentEmail"
          required
        />
        <button type="submit" class="black primary-color">Invite</button>
      </form>
    </div>
</template>

<script>
export default {
  data() {
    return {
      currentEmail: "",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  props: {
    act: {
      type: Function,
      required: true
    }
  },
  methods: {
    clearData: function() {
      this.currentEmail = "";
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

form.email-input {
  border: 1px solid theme.$text-color;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 2px;
}

form.email-input input {
  width: calc(100% - 20px);
  outline: none;
  box-sizing: border-box;
  border: 0;
  padding: 8px 10px;
}

.email-input button {
  background-color: theme.$white-background;
  border: 0;
  border-radius: theme.$button-border-radius;
  padding: 6px 8px;
}

.email-input button:hover {
  background-color: theme.$secondary-color;
}

.invite .title {
  margin-bottom: 10px;
}

</style>